import React from "react";
import { styled } from "@mui/material/styles";
import { FormControl, FormLabel, useTheme } from "@mui/material";
import { YesNoCustomControlProps } from "../Utils/Interfaces";
import { propertyHasErrors } from "./inputs/inputHelpers";
import { YesNoButtons } from "./yesNoButtons";

// TODO refactor this into two controls, one that uses onChange and one that uses merge
export const YesNoControl = (props: YesNoCustomControlProps): JSX.Element => {
    const theme = useTheme();
    const PREFIX = "YesNoControl";
    const isErrored = propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty);

    const classes = {
        yesNoControl: `${PREFIX}-yesNoControl`,
        yesNoControlLabel: `${PREFIX}-yesNoControlLabel`,
    };

    const StyledFormControl = styled(FormControl)(() => ({
        [`&.${classes.yesNoControl}`]: {
            position: "relative",
            marginTop: 9,
            marginBottom: 4,
            padding: theme.spacing(0.5),
            border: `1px solid ${isErrored ? theme.palette.error.main : theme.palette.grey[400]}`,
            borderRadius: theme.shape.borderRadius,
        },

        [`& .${classes.yesNoControlLabel}`]: {
            position: "absolute",
            top: -10,
            left: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(0, 0.8),
            fontSize: "0.75rem",
            color: isErrored ? theme.palette.error : theme.palette.text.secondary,
        },
    }));

    return (
        <>
            <StyledFormControl className={classes.yesNoControl} variant="outlined" error={isErrored} fullWidth>
                <FormLabel className={classes.yesNoControlLabel} required={props.isRequired}>
                    {props.labelText}
                </FormLabel>
                <YesNoButtons {...props} />
            </StyledFormControl>
        </>
    );
};
